import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPagesToShow = 5;
        const halfPagesToShow = Math.floor(maxPagesToShow / 2);
        
        if (totalPages <= maxPagesToShow + 2) {
            // Show all pages if total pages are few
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Logic for showing pages with ellipses
            let startPage = Math.max(1, currentPage - halfPagesToShow);
            let endPage = Math.min(totalPages, currentPage + halfPagesToShow);

            if (currentPage - 1 <= halfPagesToShow) {
                endPage = maxPagesToShow;
            }

            if (totalPages - currentPage <= halfPagesToShow) {
                startPage = totalPages - maxPagesToShow + 1;
            }

            if (startPage > 1) {
                pageNumbers.push(1);
                if (startPage > 2) {
                    pageNumbers.push('...');
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    pageNumbers.push('...');
                }
                pageNumbers.push(totalPages);
            }
        }
        
        return pageNumbers;
    };

    const pages = getPageNumbers();

    return (
        <nav className="pagination-container" aria-label="Page navigation">
            <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(1)} disabled={currentPage === 1}>
                        &laquo; First
                    </button>
                </li>
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                        &lsaquo; Prev
                    </button>
                </li>

                {pages.map((page, index) => (
                    <li key={index} className={`page-item ${page === currentPage ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}>
                        <button 
                            className="page-link" 
                            onClick={() => typeof page === 'number' && onPageChange(page)}
                            disabled={page === '...'}
                        >
                            {page}
                        </button>
                    </li>
                ))}

                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next &rsaquo;
                    </button>
                </li>
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
                        Last &raquo;
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination; 